module.exports = __webpack_public_path__ + "img/ivTest_sub53.165885cf.png";